import * as React from 'react';
import CallbackHelpers from '../helpers/CallbackHelpers';
import {Func} from '../types/Func';
import {TeamMemberFilter} from '../types/TeamMemberFilter';
import {JourneyTeamMember} from '../../reports/types/JourneyTeamMember';

export interface TeamMemberCacheProps {
  getTeamMembers: (filter: TeamMemberFilter) => JourneyTeamMember[];
  clearTeamMemberCache: Func;
  teamMemberCount: number;
  isTeamMemberCacheProcessing: boolean;
}

export const TeamMemberCache = React.createContext<TeamMemberCacheProps>({
  getTeamMembers: CallbackHelpers.ThrowNotImplemented,
  clearTeamMemberCache: CallbackHelpers.NoOp,
  teamMemberCount: 0,
  isTeamMemberCacheProcessing: false
});
